module.exports = __webpack_public_path__ + "static/media/seasonal_flat_grey.db412af2.svg";